import React, { useEffect, useState } from "react";
import { Simple } from '../../components/layouts';
import { Row, Col, Container } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import image from '../../assets/1503.png';
import { propertyDataSelectors } from '../../store/slices/propertyData';
import { useSelector } from 'react-redux';
import config from '../../config';
import axios from 'axios';
import * as moment from 'moment';
import { Loading } from '../../components/common';

const BlogDetails = (props) => {
	const manager = useSelector(propertyDataSelectors.getPropertyManager);
	const activeId = props.match.params.id;
	const [blog, setBlog] = useState([]);
	const [loading, setLoading] = useState(true);

	const getCompanyReviews = async (id) => {
		try {
			const { endPoint, baseURL, token } = config.blog;
			const response = await axios.get(`${baseURL}?endpoint=${endPoint}${id}`, { headers: { "Authorization": `Bearer ${token}` } });
			let allBlogs = response.data.filter(el => el['Blog'].id === activeId);
			setLoading(false)
			if (allBlogs.length > 0) {
				setBlog(allBlogs[0]['Blog']);
			}
		} catch (err) {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (manager.id) {
			getCompanyReviews(manager.id);
		}
	}, [manager]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Simple src={image} alt='logo'>
			<Container className="mt-5 mb-4">
				<Row>
					<Col sm={12}>
						<Breadcrumb>
							<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
							<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/blogs" }}>Blogs</Breadcrumb.Item>
							<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }} active>{blog.title}</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
				</Row>
				<Row className="justify-content-center text-center">
					<Col sm={12}>
						<Loading isLoading={loading} />
					</Col>
				</Row>
				{!loading ? <Row className="mt-4 justify-content-center">
					<Col sm={10}>
						<Row>
							<Col>
								<h2 className="mt-4 mb-2">{blog.title}</h2>
								<p className="small">Posted on {moment(blog.created).format('MMM DD, YYYY')}</p>
								<hr />
								<div className="w-100 blog_container" dangerouslySetInnerHTML={{ __html: blog.description }}>

								</div>
							</Col>
						</Row>
					</Col>
				</Row> : null}
			</Container>
		</Simple>
	)
};

export default BlogDetails;